import { toBB } from '@/utils/bb';

export type BbSubtitleTone = 'muted' | 'warning' | 'accent';

export type BbSubtitleProps = {
  chips: number;
  bbSize: number;
  tone?: BbSubtitleTone;
  /** Tailwind size override — defaults to text-[9px]. */
  className?: string;
};

const TONE_CLASS: Record<BbSubtitleTone, string> = {
  muted: 'text-muted/80',
  warning: 'text-warning/90',
  accent: 'text-accent/80',
};

/**
 * Small "N BB" label placed beneath chip counts (pot, stack, bets, bet
 * buttons). Returns null when bbSize is missing so upstream layout can
 * stay stable without conditional wrappers.
 */
export function BbSubtitle({ chips, bbSize, tone = 'muted', className = '' }: BbSubtitleProps) {
  if (!bbSize || bbSize <= 0) return null;
  return (
    <span
      className={`font-display text-[9px] uppercase tracking-wider ${TONE_CLASS[tone]} ${className}`}
    >
      {toBB(chips, bbSize)}
    </span>
  );
}
